module.exports = "/assets/f6bb6d7d861023a23f30d6d616ba4675.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3P.png
// module id = 2147
// module chunks = 0